import React, { Component } from 'react'

import Header from '../components/Header';
import About from '../components/About';
import Features from '../components/Features';
import Stats from '../components/Stats';
import Partners from '../components/Partners';
import Reviews from '../components/Reviews';
import Apply from '../components/Apply';

export default class Home extends Component {
  render() {
    return (
        <div className=''>

        <Header />
        <About />
        <Features />
        <Stats />
        <Partners />
        <Reviews />
        <Apply />

        <div className='h-[10vh]'></div>
      </div>
    )
  }
}
